import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';

export const DpCustomDivider = styled(Divider)({
	'& .MuiDivider-wrapper': {
		padding: '0',
	},
});
